import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.91 3.004 22 3l.075.003.126.017.111.03.111.044.098.052.104.074.082.073 4 4a1 1 0 0 1-1.32 1.497l-.094-.083L23 6.415v3.683a6 6 0 0 1-2.81 5.083l-.213.127-8.962 5.12a4 4 0 0 0-2.009 3.248L9 23.902V28a1 1 0 0 1-1.993.117L7 28v-4.098a6 6 0 0 1 2.81-5.082l.213-.128 8.962-5.12a4 4 0 0 0 2.009-3.248l.006-.226V6.415l-2.293 2.292a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 4-4q.053-.054.112-.097l.11-.071.114-.054.105-.035.117-.025zM22 19a1 1 0 0 1 .993.883L23 20v8a1 1 0 0 1-1.993.117L21 28v-8a1 1 0 0 1 1-1M8.993 4.883A1 1 0 0 0 7 5v10l.007.117A1 1 0 0 0 9 15V5z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconChangeOrders = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconChangeOrders);
export default Memo;
